/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Form } from '../models/Form';
import type { FormCondition } from '../models/FormCondition';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class FormService {
    /**
     * Add a form
     * @param workspaceId Workspace ID required
     * @param requestBody
     * @returns any Successfully added a form
     * @throws ApiError
     */
    public static postForm(
        workspaceId: string,
        requestBody: {
            form_type: string;
            name: string;
            form_conditions: Array<FormCondition>;
        },
    ): CancelablePromise<{
        items?: Array<Form>;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/form',
            query: {
                'workspace_id': workspaceId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                500: `Internal server error`,
            },
        });
    }
    /**
     * Delete a form
     * @param workspaceId The workspace_id of form to get or delete
     * @param id The id of form to delete
     * @returns any Successfully deleted form
     * @throws ApiError
     */
    public static deleteForm(
        workspaceId: string,
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/form/{id}',
            path: {
                'id': id,
            },
            query: {
                'workspace_id': workspaceId,
            },
            errors: {
                404: `Form not found`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * List of forms of user
     * @param workspaceId The workspace_id of form to get or delete
     * @param limit How many elements you want to fetch
     * @param offset offset from where you want to start the list
     * @returns any Successfully retrieved list of forms
     * @throws ApiError
     */
    public static getFormList(
        workspaceId: string,
        limit?: number,
        offset?: number,
    ): CancelablePromise<{
        items?: Array<Form>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/form/list',
            query: {
                'workspace_id': workspaceId,
                'limit': limit,
                'offset': offset,
            },
            errors: {
                500: `Internal server error`,
            },
        });
    }
}
